import request from '../../axios';

const PostViolationReportAdvertisement = async (
  payload: IViolationReportAds,
) => {
  const newPayload = {
    ad_type: payload.ad_type,
    description: payload.description,
    advertisement_guid: payload.advertisement_guid,
    Reason_report_guid: payload.Reason_report_guid,
  };

  await request.post(`api/v2/store/violation-report-advertisement`, {
    ...newPayload,
  });
};

export default PostViolationReportAdvertisement;
